import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import GoogleLogin, { GoogleLogout } from 'react-google-login';
import { toast, ToastContainer } from 'react-toastify';
import Logo from '../assets/img/logo_main.png';
import { gapi } from 'gapi-script';
import { useHistory } from 'react-router-dom';
import { GoogleLoginContext } from '../contexts/GoogleLoginContext';
import Loading from './Loader/Loading';
// import { GoogleLoginContext } from '../contexts/GoogleLoginContext';

const GoogleScreen = () => {

    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const initClient = () => {
            gapi.auth2.init({
                clientId: clientId,
                scope: 'https://www.googleapis.com/auth/analytics.readonly',
                plugin_name: "beyown"
            });
        };
        gapi.load('client:auth2', initClient);

    });


    let history = useHistory();
    const { profile, ProfileAdded, clientId, setToken } = useContext(GoogleLoginContext);


    const onSuccess = (res) => {
        // setProfile(res.profileObj);
        // console.log(res.profileObj);
        setLoading(true)
        ProfileAdded(res.profileObj)
        console.log('logged in');
        // console.log(myprofile.imageUrl);
        toast.success('Google Analytics has been enabled Successfully!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",

        })
        setLoading(false)
        history.push("/admin/dashboard");
        setToken(res.tokenObj.access_token);
        console.log(res.tokenObj.access_token);



    };

    const onFailure = (err) => {
        console.log('failed', err);
        // history.push("/admin/dashboard");
    };

    if (loading) {
        return <Loading />
    }

    return (
        <div>


            <div className="d-flex align-items-center  justify-content-center auth px-0 ">
                <div className="d-flex   align-items-center ">

                    <div className="auth-form-light  justify-content-center text-left py-5 mt-5 px-4 px-sm-5 shadow-lg">
                        <div className="d-flex justify-content-center">
                            <img src={Logo} alt="logo" />
                        </div>

                        <h6 className="font-weight-light mt-3">Sign in to Google to Get Full Analytics Dashboard Access .</h6>

                        <Form onSubmit={(e) => { e.preventDefault() }} className="pt-2">




                            <div className="mb-2 d-flex justify-content-center">
                                {
                                    profile ? (
                                        <div className="my-3 d-flex justify-content-around align-items-center shadow-lg p-3">
                                            {/* <img src={profile?.imageUrl} alt="user image" />
              <h3>User Logged in</h3>
              <p>Name: {profile?.name}</p>
              <p>Email Address: {profile?.email}</p>
              <br /> */}
                                            <button type="button" className="btn btn-primary btn-rounded" >
                                                Load/Refresh Data
                                            </button>
                                            <br />
                                            {/* <GoogleLogout className="px-2 rounded shadow-lg" clientId={clientId} buttonText="Log out" onLogoutSuccess={logOut} /> */}
                                        </div>
                                    ) : (
                                        <div className="my-3 d-flex justify-content-around align-items-center shadow-lg p-3">
                                            <GoogleLogin
                                                clientId={clientId}
                                                buttonText="Sign in with Google"
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                                cookiePolicy={'single_host_origin'}
                                                isSignedIn={true}
                                            />
                                        </div>
                                    )
                                }
                            </div>

                        </Form>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default GoogleScreen